import React from 'react';
import AuthenticationFactorListPicker
  from 'Views/Page/Content/Templates/SettingsTemplate/Content/AuthenticationFactorTemplate/AuthenticationFactorsCard/AuthenticationFactorListPicker';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import { useTheme } from '@material-ui/core/styles';
import useMobileLayout from 'Hooks/useMobileLayout';

const AuthenticationFactorTemplate = () => {
  const theme = useTheme();
  const isMobile = useMobileLayout();

  useBackgroundColor(isMobile ? undefined : theme.palette.facet.lightGray);

  return (
    <AuthenticationFactorListPicker />
  );
};

export default AuthenticationFactorTemplate;
